module.exports = __webpack_public_path__ + "img/223.3d5e806a.png";